export const FAQ_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": [
    "Organization",
    "Corporation"
   ],
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt"
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR"
  },
  {
   "@type": "FAQPage",
   "@id": "https://everest.ind.br/pt/perguntas-frequentes#webpage",
   "url": "https://everest.ind.br/pt/perguntas-frequentes",
   "name": "Perguntas Frequentes | Everest",
   "description": "Tire suas dúvidas sobre os purificadores de água e máquinas de gelo Everest: instalação, manutenção, filtros e muito mais.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/perguntas-frequentes#breadcrumb"
   },
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Qualquer marca de filtro ou refil se encaixa nos purificadores?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Não. Os purificadores Everest foram projetados para trabalhar somente com o Refil Original Everest."
     }
    },
    {
     "@type": "Question",
     "name": "O processo de filtragem é o mesmo para todos os modelos?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Sim, todos os modelos dos purificadores possuem o mesmo elemento filtrante."
     }
    },
    {
     "@type": "Question",
     "name": "Após instalado, quanto tempo leva para a água gelar?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Aproximadamente 60 minutos após ligar o aparelho na rede elétrica, tempo necessário para gelar a água do reservatório interno."
     }
    },
    {
     "@type": "Question",
     "name": "O purificador altera o pH da água?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Não. O processo de filtragem não altera o pH da água, apenas reduz cloro e impurezas."
     }
    },
    {
     "@type": "Question",
     "name": "Como deve ser feita a limpeza do purificador?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "A limpeza deve ser feita com pano limpo e úmido e detergente neutro, secando cuidadosamente."
     }
    },
    {
     "@type": "Question",
     "name": "O filtro remove ferro da água?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Remove apenas ferro em forma de partículas (ferrugem). Ferro dissolvido não é retido."
     }
    },
    {
     "@type": "Question",
     "name": "O purificador pode ser instalado em bancada?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Sim, pode ser instalado em bancada, exceto o modelo Everest Baby."
     }
    },
    {
     "@type": "Question",
     "name": "Os purificadores de água gelada são econômicos?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Sim. O sistema de refrigeração por compressor é eficiente e consome energia apenas para gelar a água."
     }
    },
    {
     "@type": "Question",
     "name": "Preciso de ponto de água na parede para instalar?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Não. O purificador pode ser instalado diretamente na torneira."
     }
    },
    {
     "@type": "Question",
     "name": "Qual a vida útil do refil?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "A vida útil média é de 4.000 litros ou de 9 a 12 meses, dependendo do uso e da qualidade da água."
     }
    }
   ]
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/perguntas-frequentes#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Perguntas Frequentes",
     "item": "https://everest.ind.br/pt/perguntas-frequentes"
    }
   ]
  }
 ]
}
